import * as API from '@/API';
import NotAllowedDialog from '@/Components/NotAllowedDialog/NotAllowedDialog';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

const AuthorizedRoute = ({ path, children }: { path: string; children: React.ReactElement }): React.ReactElement => {
    const navigate = useNavigate();
    const [checkingAuth, setCheckingAuth] = useState(true);
    const [showNotAllowed, setShowNotAllowed] = useState(false);

    // On initial load of the component on the route, see if we are allowed to access the page or not
    const load = async (): Promise<void> => {
        const canOpen = await API.general.checkIfAllowedToOpen(path);
        setCheckingAuth(false);
        setShowNotAllowed(!canOpen.Data?.AllOk);
    };

    useEffect(() => {
        void load();
    }, [path]);

    const onOk = (): void => {
        navigate(-1);
    };

    if (checkingAuth) {
        return <></>;
    }

    if (showNotAllowed) {
        return <NotAllowedDialog isOpen={showNotAllowed} onOk={onOk} />;
    }

    return <>{children}</>;
};

export default AuthorizedRoute;
